<div class="contents">
  <div class="index-box">{{ templateItem.order ?? 1 }}</div>
  <span
    [ngClass]="{ 'disabled text-navy-400': !template?.permissions?.can_edit || template.tags.length < 2 }"
    cdkDragHandle
    class="icon-draggable text-blue-700 text-[20px] cursor-pointer"
  ></span>
  <app-floating-input
    [name]="'name' + templateItem.id"
    (ngModelChange)="fieldChanged('name', $event)"
    [ngModel]="templateItem.name"
    [verticalSpacing]="false"
    [disabled]="!template?.permissions?.can_edit"
  ></app-floating-input>

  <span
    (click)="minusClicked()"
    [ngClass]="{ 'disabled hidden': !template?.permissions?.can_edit, 'disabled grayscale': template.tags.length < 2 }"
    class="icon-minus-box add-remove-btn"
  ></span>
  <span
    (click)="plusClicked()"
    [ngClass]="{ 'disabled hidden': !template?.permissions?.can_edit }"
    class="icon-plus-box add-remove-btn"
  ></span>
</div>
